import { faqItems } from '@/mocks/homeData';

export default function FAQ() {
  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问答</h2>
          <p className="mt-2 text-sm text-foreground-500">关于网红黑料情报站的常见问题解答</p>
        </div>

        <div className="space-y-4">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="mt-3 pl-9 text-sm text-foreground-600 leading-relaxed">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}